import React, { useCallback, useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { ROLES } from "../../../../constansts/Roles";
import {
   adhocTripListAsync,
   adhocTripListByPaginationAsync,
} from "../../../../redux/features/adhocTripSlice";
import moment from "moment";
import AdhocTripReport from "./AdhocTripReport";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../../../Hooks/useDebounce";
import { getAdhocTripByPaginationApiCall } from "../../../../Api/api";
import TripTable from "./TripTable";
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

const AdhocTripView = () => {
   const [params] = useSearchParams(); // Get trip_status from URL params
   const trip_status = params.get("trip_status");
   const review_status = params.get("review_status");

   const [records, setRecords] = useState([]);
   const [listPagination, setListPagination] = useState(null);
   const [limit, setLimit] = useState(10);
   const [page, setPage] = useState(0);
   const [tripStatusFilter, setTripStatusFilter] = useState(trip_status || ""); // Set initial filter from params
   const [searchTerm, setSearchTerm] = useState("");

   const trip = useSelector((state) => state.adhocTrip);

   const userRoleId = useSelector((state) => state?.auth?.user?.data?.user?.role_id);
   const userId = useSelector((state) => state?.auth?.user?.data?.user?.id);

   const debouncedSearchTerm = useDebounce(searchTerm, 500);

   let roleName;
   // Finding the rolename from roles
   for (const key in ROLES) {
      if (ROLES[key] === userRoleId) {
         roleName = key;
      }
   }

   const dispatch = useDispatch();
   const navigate = useNavigate();

   const fetchTrips = useCallback(
      async (search = "") => {
         if (!roleName || !userId) return;

         dispatch(backdropLoadingAction(true));

         try {
            const { data: response } = await getAdhocTripByPaginationApiCall(
               limit,
               page,
               trip_status,
               review_status,
               search,
            );
            if (response.statusCode === 200) {
               setRecords(response?.data);
               setListPagination(response?.pagination);
            }
         } catch (error) {
            //toast.error("Failed to fetch trips.");
         } finally {
            dispatch(backdropLoadingAction(false));
         }
      },
      [limit, page, roleName, userId, review_status, trip_status],
   );

   useEffect(() => {
      fetchTrips(debouncedSearchTerm);
   }, [fetchTrips, debouncedSearchTerm]);

   const handleStatusFilter = (filterName, status) => {
      const newStatus = status === "all" ? "" : status;
      setTripStatusFilter(newStatus);
      setPage(0); // Reset to first page when filters change
      navigate(`/trip/adhoc/view/?${filterName}=${newStatus}`); // Update URL
   };

   useEffect(() => {
      setPage(0); // Only once when debounced search term changes
   }, [debouncedSearchTerm]);

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();

      setSearchTerm(searchText);
   };

   return (
      <div>
         <BodyHeader title="Trip List" />

         <div className="px-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
               <Stack direction="row" alignItems="center" spacing={1}>
                  <div>
                     <Typography>Trip Status</Typography>
                     <ToggleButtonGroup
                        color="primary"
                        value={trip_status}
                        exclusive
                        onChange={(_, value) => handleStatusFilter("trip_status", value)}
                        aria-label="Platform"
                     >
                        <ToggleButton value="">All</ToggleButton>
                        <ToggleButton value="open">Open Trip</ToggleButton>
                        <ToggleButton value="closed">Closed Trip</ToggleButton>
                     </ToggleButtonGroup>
                  </div>
                  <div>
                     <Typography>Review Status</Typography>
                     <ToggleButtonGroup
                        color="primary"
                        value={review_status}
                        exclusive
                        onChange={(_, value) =>
                           handleStatusFilter("review_status", value)
                        }
                        aria-label="Platform"
                     >
                        <ToggleButton value="">All</ToggleButton>
                        <ToggleButton value="pending">Pending</ToggleButton>
                        <ToggleButton value="approved">Approved</ToggleButton>
                        <ToggleButton value="rejected">Rejected</ToggleButton>
                     </ToggleButtonGroup>
                  </div>
               </Stack>
               <div className=" d-flex gap-2">
                  <CustomInput
                     inputType="text"
                     placeholder="Search..."
                     id="search"
                     onChange={(e) => handleFilter(e)}
                     containerStyle={{ marginRight: 20 }}
                  />
                  <AdhocTripReport />
               </div>
            </div>
            {/* <CustomTable columns={columns} keyField="tripid" data={records} sortable /> */}
            <TripTable
               rows={records}
               limit={limit}
               page={page}
               setLimit={setLimit}
               setPage={setPage}
               listPagination={listPagination}
            />
         </div>
      </div>
   );
};

export default AdhocTripView;
